import React, {useEffect, useState} from "react";
import {useDebouncedEffect} from "./hooks";
import {InputNumber} from "antd";

const keyboardDebounceDelay = 250;

// todo this also debounces accepting the the new _value
// WrappedComponent should except value & onOutputChange props
function debouncedInput(WrappedComponent, defaultDelay = 250) {

    const hoc = React.forwardRef(function (
        {
            delay = defaultDelay,
            onChange: _onChange = console.log,
            value: _value,
            ...props
        }, ref) {
        const [previousValue, setPreviousValue] = useState(null);
        const [dbValue, setDbValue] = useState(null);

        useEffect(() => {
            if (_value !== previousValue) {
                setDbValue(_value);
                setPreviousValue(_value);

                // todo not sure this is good idea'
                //  FYI this was triggering react warning until is was wrapped in useEffect
                //  it was changing the state of a parent while it rendered - this moves it to after
                //console.log('Initial value:', dbValue, _value, previousValue);
                if (_value !== dbValue) {
                    _onChange(_value);  // spit it right back out
                }
            }
        }, [_value, previousValue, dbValue]);

        useDebouncedEffect(() => {
            if (dbValue !== _value) {
                //console.log('Debounced..:', dbValue, typeof dbValue, _value, typeof _value);
                _onChange(dbValue);
            }
        }, delay, [dbValue, _value]);

        return <WrappedComponent value={dbValue} onChange={setDbValue} ref={ref} {...props}/>;
    });

    return hoc;
}

export const DebounceNumber = debouncedInput(InputNumber, keyboardDebounceDelay);